<template>
    <div id="download">
        <Header :title="title" />

        <main class="MainCon bottom0 bg_white">
            <div class="ml7 mr7 mt7">
                <div class="flexBox flexBetween">
                    <div class="flexBox">
                        <div class="appLogo"><img src="@/assets/images/logo.png" /></div>
                        <div class="ml7"><span class="f12 b color_333 lh24 mt10">爱返利</span><br><span
                                class="f8 color_999 lh18">够省钱  够聪明</span></div>
                    </div>
                    <div>
                        <div class="appDownloadBtn" v-on:click="androidTo()"><em
                                class="iconfont icon-anzhuo"></em>&nbsp;Android 下载
                        </div>
                        <div class="appDownloadBtn mt5" v-on:click="iPhoneTo()"><em
                                class="iconfont icon-pingguo f12"></em>&nbsp;&nbsp;iPhone 下载
                        </div>
                    </div>
                </div>
                <div class="swiper-container mt10" id="appBanner">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide"><img src="@/assets/images/appBanner1.jpg" /></div>
                        <div class="swiper-slide"><img src="@/assets/images/appBanner2.jpg" /></div>
                        <div class="swiper-slide"><img src="@/assets/images/appBanner3.jpg" /></div>
                        <div class="swiper-slide"><img src="@/assets/images/appBanner4.jpg" /></div>
                    </div>
                </div>
            </div>
        </main>


    </div>
</template>

<script>
    import Swiper from 'swiper';
    import '@/assets/css/swiper.css';
    import {appService} from '../services/app';
    import {mapState} from 'vuex';
    import Header from '../components/Header';
    import {isMobile} from '../libs/utils';

    export default {
        components: {Header},
        data() {
            return {
                title: 'APP下载',
                android_download_url: '',
                ios_download_url: '',
            };
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin;
            }
            this.fetchDownloadAppUrl();
            this.initSwiper();
        },
        methods: {
            fetchDownloadAppUrl: function () {
                let self = this;

                appService.fetchDownloadAppUrl().then((res) => {
                    let {code, data} = res;
                    if (code === 1) {
                        self.android_download_url = data.android_download_url;
                        self.ios_download_url = data.ios_download_url;
                    }
                });
            },
            initSwiper: function () {
                let self = this;
                setTimeout(function () {
                    self.$nextTick(() => {
                        new Swiper('#appBanner', {
                            autoplay: {
                                delay: 2500,
                                disableOnInteraction: false,
                            },
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'fraction',
                            },
                        });
                    });
                }, 100);
            },
            androidTo: function () {
                let self = this;
                window.location.href = self.android_download_url;
            },
            iPhoneTo: function () {
                let self = this;
                window.location.href = self.ios_download_url;
            },
        }
    }
</script>

<style scoped>

</style>
